import { call, put, all } from "redux-saga/effects";
import { Types } from './types'

function* initialHandler() {
  const alert = {
    open: false,
    message: "",
    severity: undefined
  }

  yield put({ 
    type: Types.SET_ALERT,
    payload: alert
  });

}

function* rootSaga() {
  yield all([
    yield call(initialHandler)
  ]);
}

export default rootSaga;